import React, { useContext, useState, useEffect } from "react";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import SaveIcon from "@material-ui/icons/Save";
import CreateIcon from "@material-ui/icons/Create";
import Grid from "@material-ui/core/Grid";
import { useTranslation } from "react-i18next";
import AutomService from "../../../../../services/AutomService/AutomService";
import triggerService from "../../../../../services/triggerService/triggerService";
import { editDataRun } from "../../../../../helpers/helper";

import EditAutomName from "../editAction/editAutomName/EditAutomName";
import { setFlowtoStorage } from "../../../../../helpers/historyHandler";
// socket connection
import { connection } from '../../../../../helpers/socket';
// start socket requirement
import {
    setUnReadNotificationCount,
    newNotification
} from '../../../../../store/actions/notification/NotificationActions';
import { setAutomsQueue } from '../../../../../store/actions/automsQueue/automsQueue';
import { setQueueActivityLog } from "../../../../../store/actions/queueActivityLog/QueueActivityLogActions";
import { pushDebugs } from '../../../../../store/actions/debugger/debugger';
// end
import {
    valueController,
    findDebugAction,
    handleDebugArray,
} from "../../../../../helpers/helper";
import PublishRoundedIcon from "@material-ui/icons/PublishRounded";
import { DataContext } from "../FlowConfiguration";
import Publish from "../../publish/Publish";
import RunningModal from "../component/RunningModal";
import QueueService from "../../../../../services/QueueService/QueueService";
import WaitingQueueModal from "../component/WaitingQueueModal";
import BugReportIcon from "@material-ui/icons/BugReport";
import MateDrive from "./../../../../../components/MateDrive/MateDrive";
import StorageIcon from "@material-ui/icons/Storage";
import UpgradeFlow from "../../UpgradeFlow/UpgradeFlow";
import cloneDeep from "lodash/cloneDeep";
import Info from "../editAction/components/Info";
import Schedule from "../../Schedule/Schedule";
import triggerIcon from "../../../../../assets/icons/Trigger.png";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import TriggerModal from "./TriggerModal";
import { useSetRecoilState, useRecoilValue } from "recoil";
import { alertState, debugList, rolePermission } from "../../../../../recoil-store/recoil-state";
import { withStyles } from "@material-ui/core/styles";

const StyledMenu = withStyles({
    paper: {
        border: "1px solid #d3d4d5",
    },
})((props) => (
    <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
        }}
        transformOrigin={{
            vertical: "top",
            horizontal: "center",
        }}
        {...props}
    />
));
const Header = (props) => {
    const { t } = useTranslation();
    const [openPublish, setOpenPublish] = useState(false);
    const [openEdit, setOpenEdit] = useState(false);
    const context = useContext(DataContext);
    const [publishFlow, setPublishFlow] = useState([]);
    const [flowStatus, setFlowStatus] = useState(0);
    const [openWaitingQueueModal, setOpenWaitingQueueModal] = useState(false);
    const [numberQueue, setNumberQueue] = useState(0);
    const [errorMessage, setErrorMessage] = useState("");
    const [operationId, setOperationId] = useState("");
    const [openDrive, setOpenDrive] = useState(false);
    const [automVersion, setAutomVersion] = useState([]);
    const [openUpgrade, setOpenUpgrade] = useState(false);
    const [loading, setLoading] = useState(false);
    const [openSchedule, setOpenSchedule] = useState(false);
    const [reCheck, setReCheck] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [isRunning, setIsRunning] = useState(false);
    const [triggerModal, setTriggerModal] = useState(false);
    const [trigger, setTrigger] = useState(false);
    const [triggerType, setTriggerType] = useState('');
    const setAlert = useSetRecoilState(alertState);
    const setDebugs = useSetRecoilState(debugList);
    const permissions = useRecoilValue(rolePermission);

    useEffect(() => {
        setLoading(true);

        async function fetchAutomVersionData() {
            if (props.automDetail?.id) {
                const response = await AutomService.getAutomVersion(
                    props.automDetail?.id
                );
                if (response) {
                    if (response.status) {
                        setAutomVersion(response.data);
                    }
                }
            }
        }

        setLoading(false);
        fetchAutomVersionData().then((r) => r);
    }, [props.automDetail?.id, permissions?.data, loading]);
    useEffect(() => {
        if (props.automDetail?.id) {
            checkIsRunning().then(r => r);
        }
    }, [props.automDetail?.id, reCheck]);
    // check autom type and if trigger (email,schedule) update setTrigger state
    const checkIsRunning = async () => {
        let type;
        if (props.automDetail?.integration_type === "SCHEDULE") {
            type = "SCHEDULE";
        } else if (props.automDetail?.trigger_type && props.automDetail?.trigger_type.includes('email')) {
            type = "EMAIL";
        }
        if (type) {
            const response = await triggerService.checkIsRunningStatus(props.automDetail?.id, type);
            setIsRunning(response.data.is_running);
            setTrigger(true);
            setTriggerType(type);
        } else {
            setTrigger(false);
        }
    }
    const handleClick = () => {
        setOpenEdit(!openEdit);
    };

    //  While saved, delete icon then  send it the backend.
    function editDataSave(node) {
        node.map((item) => {
            if (item.acceptsNewChildren) {
                editDataSave(item.children);
            }
            delete item.image;
            return item;
        });
        return node;
    }

    const getDataForSave = () => {
        let saveData = cloneDeep(context.items.children);
        let stopAction = cloneDeep(context.initialFlowItem[0]);
        saveData = editDataSave(saveData);
        saveData.splice(0, 1);
        setFlowtoStorage("flow", context.items.children);
        stopAction.order =
            context.items.children[context.items.children.length - 1].order + 1;
        setFlowtoStorage("stopAction", stopAction);
        saveData.push(stopAction);
        return {
            autom_id: props.automDetail.id,
            operationId,
            version_id: props.selectAutomVersion,
            updatingFields: [
                { field_name: "flow", field_value: saveData },
                { field_name: "diagram", field_value: props.diagramData },
            ],
        };
    };

    // RUNNING FLOW
    const newRunningData = (opId, actions) => {
        setFlowtoStorage("flow", context.items.children);
        return {
            flowActions: {
                id: props.automDetail.id,
                name: props.automDetail.name,
                description: props.automDetail.description,
                integration_type: props.automDetail.integration_type,
                mate_id: props.automDetail.mate_id,
                actions,
                operationId: opId,
                isDebugging: props.debuggingStart,
            },
        };
    };

    const saveFlow = async (e) => {
        // Disable save button click event to prevent double click
        if (!e.target.disabled) {
            e.target.disabled = true;
            const newFormData = getDataForSave();
            const response = await AutomService.updateAutom(
                newFormData,
                props.automDetail.id
            );
            if (response?.status) {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t("MESSAGES.AUTOMS.AUTOM-SAVED"),
                    severity: 'success'
                }))

            } else {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t("MESSAGES.AUTOMS.AUTOMS-ADDED-FAILED"),
                    severity: 'error'
                }))
            }
            setTimeout(() => {
                // Enable save button click event
                e.target.disabled = false;
            }, 1000);
        }
    };

    const runFlow = async () => {
        let stopAction = cloneDeep(context.initialFlowItem[0]);
        stopAction.order =
            context.items.children[context.items.children.length - 1].order + 1;
        let cloneData = cloneDeep(context.items);
        cloneData.children[0].actionName === "Start" &&
            cloneData.children.splice(0, 1);
        if (props.debuggingStart) {
            let debugAction = [];
            //finding is debugging fields to be true  return actions
            findDebugAction(cloneData.children, debugAction);
            if (debugAction[0] !== undefined) {
                await handleDebugArray(cloneData.children);
            } else {
                cloneData.children.push(stopAction);
            }
        } else {
            cloneData.children.push(stopAction);
        }
        setFlowtoStorage("stopAction", stopAction);
        const controlData = cloneData.children;
        const isNullControl = valueController(controlData, []);
        if (controlData.length > 0 && isNullControl.indexOf(false) === -1) {
            // generate Operation ID
            cloneData.children = editDataRun(cloneData.children);
            const generateOperationResp = await AutomService.generateOperation(
                props.automDetail.id,
                props.automDetail.mate_id,
                props.debuggingStart
            );
            if (generateOperationResp && generateOperationResp.status) {
                setOperationId(generateOperationResp.data.operationId);
                // resp : number of autom waiting
                const responseQueue = await QueueService.getQueueStatus();
                let queue = false; // queue = false because we want flow to start directly
                if (responseQueue?.status) {
                    // open WaitingQueueModal
                    if (responseQueue?.data?.count > 0 && queue) {
                        //before save flow
                        const newFormData = getDataForSave();
                        const response = await AutomService.updateAutom(
                            newFormData,
                            props.automDetail.id,
                            operationId
                        );
                        //then open waiting queue modal
                        if (response) {
                            // number of queue
                            setNumberQueue(responseQueue?.data?.count);
                            setOpenWaitingQueueModal(true);
                        }
                    }
                    //running flow now
                    else {
                        // socket re connection
                        connection(props);
                        //set open running modal
                        props.setOpenRunningModal(true);
                        const newFormData = newRunningData(
                            generateOperationResp.data.operationId,
                            cloneData.children
                        );
                        const response = props.debuggingStart
                            ? await AutomService.debuggingAutom(newFormData)
                            : await AutomService.runAutom(newFormData);
                        if (response?.status) {
                            // setFlowstatus :1 response success
                            setFlowStatus(1);
                            setAlert(alert => ({
                                ...alert,
                                show: true,
                                message: t("MESSAGES.AUTOMS.AUTOM-RUN"),
                                severity: 'success'
                            }))
                        } else {
                            // setFlowstatus :2 response fail
                            setFlowStatus(2);
                            if (response && response.message.includes("System Error:")) {
                                setErrorMessage(response.message);
                                //setErrorMessage(response.message.replace("System Error:", ""));
                            } else {
                                setErrorMessage(
                                    t("FLOW-MESSAGES.LIBRARY." + response?.message)
                                );
                            }
                        }
                    }
                }
            }
        } else {
            setAlert(alert => ({ ...alert, show: true, message: t("ACTIVE-DIRECTORY.NOT-NULL"), severity: 'error' }))
        }
    };

    // clicked debug icon color control
    //all action isdebugging fields set false
    function handleDebugIconShowControl(nodes) {
        for (let i = 0; i < nodes.length; i++) {
            nodes[i].isDebugging = false;
            if (nodes[i]?.acceptsNewChildren) {
                handleDebugIconShowControl(nodes[i].children);
            }
        }
    }

    // debugging start
    function handleDebugging() {
        if (props.debuggingStart === false) {
            handleDebugIconShowControl(context.items.children);
        }
        setDebugs([]);
        props.setDebuggingStart(!props.debuggingStart);
    }

    // changed autom version
    async function handleSelectAutomVersion(e) {
        props.setSelectAutomVersion(e.target.value);
        const response = await AutomService.getByAutomVersion(e.target.value);
        if (response) {
            if (response.status) {
                if (response.data.flow !== null && Array.isArray(response.data.flow)) {
                    let flow = props.setInitialAction(response.data.flow);
                    context.items.children.splice(1, context.items.children.length - 1);
                    context.items.children.push(...flow);
                    context.setItems(context.items);
                    props.setRender(true);
                }
            }
        }
    }

    const handleOpenPublish = () => {
        const controlData = cloneDeep(context.items.children);
        controlData.splice(0, 1);
        let stopAction = cloneDeep(context.initialFlowItem[0]);
        controlData.push(stopAction);
        const isNullControl = valueController(controlData, []);
        if (
            context.items.children.length > 0 &&
            isNullControl.indexOf(false) === -1
        ) {
            setOpenPublish(true);
            setPublishFlow(controlData);
        } else {
            setAlert(alert => ({ ...alert, show: true, message: t("ACTIVE-DIRECTORY.NOT-NULL"), severity: 'error' }))
        }
    };
    const handleEmailTriggerMenu = (event) => {
        if (trigger) {
            setAnchorEl(event.currentTarget);
        }
    };
    const handleClose = () => {
        if (trigger) {
            setAnchorEl(null);
        }
    };
    const handleStart = async () => {
        const response = await triggerService.triggerStart({
            autom_id: props?.automDetail?.id,
            type: triggerType,
        });
        if (response) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.AUTOMS." + response.message),
                severity: response?.status ? 'success' : 'error'
            }))
            if (response?.status) {
                //success
                setIsRunning(true);
            }
        }
    };
    const handleStop = async () => {
        const response = await triggerService.triggerStop({
            autom_id: props?.automDetail?.id,
            type: triggerType,
        });
        if (response) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.AUTOMS." + response.message),
                severity: response?.status ? 'success' : 'error'
            }))
            if (response?.status) {
                setIsRunning(false);
            }
        }
    };
    return (
        <div className="top-tabs" style={{ display: "flex", paddingLeft: 0 }}>
            <Grid item xs={3}>
                <div className="left-side">
                    <div
                        style={{
                            color: props.debuggingStart ? "#D75E5E" : "#BCBFCA",
                            marginTop: -1,
                            cursor: "pointer",
                        }}
                        className="right-side button"
                        onClick={handleDebugging}
                    >
                        <BugReportIcon />
                    </div>
                    <Info value={props.automDetail?.name} placement="bottom">
                        <h3>{props.automDetail?.name}</h3>
                    </Info>
                    {/* {props.automDetail?.integration_type === "TRIGGER" ? (
                        <div className="webhook-icon"
                            onClick={() => setTriggerModal(true)}>
                            <img
                                className="right-side button"
                                src={triggerIcon}
                                alt="autommate"
                            />
                        </div>
                    ) : null}
                    {props.automDetail?.integration_type === "SCHEDULE" ? (
                        <div className="webhook-icon">
                            <img
                                alt="autommate"
                                className="right-side button"
                                style={{ opacity: 0.3 }}
                                onClick={() => setOpenSchedule(true)}
                                src="data:image/svg+xml;base64,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"
                            />
                        </div>
                    ) : null} */}
                </div>
            </Grid>
            <Grid item xs={9}>
                <div className="right-side">
                    <button onClick={() => setOpenDrive(true)}>
                        <Info value="Mate Drive" placement="bottom">
                            <StorageIcon style={{ color: "#8F94A6", paddingRight: "5px" }} />
                        </Info>
                    </button>
                    <div className="tabs-seperator" />
                    {permissions?.data.includes("CUSTOMAUTOMS_UPDATE") && (
                        <button onClick={() => handleClick()}>
                            <Info value={t("CONTENT.FLOW.EDIT")} placement="bottom">
                                <CreateIcon style={{ color: "#8F94A6", paddingRight: "5px" }} />
                            </Info>
                        </button>
                    )}
                    <div className="tabs-seperator" />
                    <div>
                        <button
                            style={{ cursor: "pointer" }}
                            aria-controls="email-trigger-menu"
                            aria-haspopup="true"
                            onClick={(e) => runFlow()}
                            onMouseEnter={(e) => handleEmailTriggerMenu(e)}
                        >
                            <Info value={t("CONTENT.FLOW.RUN")} placement="bottom">
                                <PlayArrowIcon
                                    style={{ color: "#8F94A6", paddingRight: "5px" }}
                                />
                            </Info>
                        </button>
                        <StyledMenu
                            style={{ marginTop: 10 }}
                            id="email-trigger-menu"
                            anchorEl={anchorEl}
                            autoFocus={false}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                            MenuListProps={{ onMouseLeave: handleClose }}
                        >
                            <MenuItem style={{ fontSize: 11, fontWeight: "600" }} onClick={runFlow}>
                                {t("CONTENT.FLOW.RUN-FLOW" + (trigger ? "-IMMEDIATELY" : ""))}
                            </MenuItem>
                            {trigger &&
                                (isRunning ? (
                                    <MenuItem
                                        style={{ fontSize: 11, fontWeight: "600" }}
                                        onClick={handleStop}
                                    >
                                        {t("CONTENT.FLOW.STOP-" + triggerType)}
                                    </MenuItem>
                                ) : (
                                    <MenuItem
                                        style={{ fontSize: 11, fontWeight: "600" }}
                                        onClick={handleStart}
                                    >
                                        {t("CONTENT.FLOW.START-" + triggerType)}
                                    </MenuItem>
                                ))}
                        </StyledMenu>
                    </div>
                    <div className="tabs-seperator" />
                    {permissions?.data.includes("CUSTOMAUTOMS_UPDATE") && (
                        <button onClick={(e) => saveFlow(e)}>
                            <Info value={t("CONTENT.FLOW.SAVE")} placement="bottom">
                                <SaveIcon style={{ color: "#8F94A6", paddingRight: "5px" }} />
                            </Info>
                        </button>
                    )}
                    <div className="tabs-seperator" />
                    {permissions?.data.includes("CUSTOMAUTOMS_PUBLISH") && (
                        <button
                            onClick={() => handleOpenPublish()}
                            style={{
                                pointerEvents: context.items.children.length < 2 && "none",
                            }}
                        >
                            <Info value={t("CONTENT.FLOW.PUBLISH")} placement="bottom">
                                <PublishRoundedIcon
                                    style={{ color: "#8F94A6", paddingRight: "5px" }}
                                />
                            </Info>
                        </button>
                    )}
                    {/* <div className="tabs-seperator" />
                  <button onClick={() => handleOpenPublish()}>
                    <StorageIcon style={{ color: "#8F94A6", paddingRight: "5px" }} />
                    <span>Data Store</span>
                  </button>
          
                  <div className="tabs-seperator" />
                  <button disabled>
                    <span>Version</span>
                  </button>
          
                  <FormControl variant="outlined" fullWidth>
                    <Select
                      value={props.selectAutomVersion}
                      onChange={handleSelectAutomVersion}
                      style={{ height: 20 }}
                    >
                      {automVersion &&
                        automVersion?.length &&
                        automVersion?.map((item, index) => (
                          <MenuItem key={index} value={item.id}>{item.version}</MenuItem>
                        ))}
                    </Select>
                  </FormControl>
          
                  <div className="tabs-seperator" />
                  <button onClick={() => handleOpen(setOpenUpgrade, setPublishFlow)}>
                    <ExitToAppIcon style={{ color: "#8F94A6", paddingRight: "5px" }} />
                    <span>Upgrade</span>
                  </button> */}
                </div>
            </Grid>
            {openEdit && (
                <EditAutomName
                    automDetail={props.automDetail}
                    setAutomDetail={props.setAutomDetail}
                    setOpenEdit={setOpenEdit}
                    setReCheck={setReCheck}
                    reCheck={reCheck}
                    setFirstRender={props.setFirstRender}
                    automaticallyVariableCreation={props.automaticallyVariableCreation}
                />
            )}
            {openPublish && (
                <Publish
                    flow={publishFlow}
                    variables={props.variables}
                    automDetail={props.automDetail}
                    setOpenPublish={setOpenPublish}
                />
            )}
            {props.openRunningModal && (
                <RunningModal
                    flowStatus={flowStatus}
                    setOpen={props.setOpenRunningModal}
                    setFlowStatus={setFlowStatus}
                    errorMessage={errorMessage}
                    operationId={operationId}
                    mateId={props.automDetail.mate_id}
                />
            )}
            {openWaitingQueueModal && (
                <WaitingQueueModal
                    setOpen={setOpenWaitingQueueModal}
                    automDetail={props.automDetail}
                    numberQueue={numberQueue}
                />
            )}
            {openDrive && (
                <MateDrive setOpen={setOpenDrive} flowId={props.automDetail?.id} />
            )}
            {openUpgrade && (
                <UpgradeFlow
                    setOpen={setOpenUpgrade}
                    automDetail={props.automDetail}
                    diagram={[]}
                    automVersion={automVersion}
                    flow={publishFlow}
                />
            )}
            {openSchedule && (
                <Schedule
                    setOpen={setOpenSchedule}
                    automId={props.automDetail?.id}
                />
            )}
            {triggerModal && (
                <TriggerModal
                    setOpen={setTriggerModal}
                    setOpenVariable={props.setOpenVariable}
                    variables={props.variables}
                    automDetail={props.automDetail}
                />
            )}
        </div>
    );
};

export default Header;
